import { StandardEvents } from '@shopify/events';

// The native picker owns the photo, price, availability and cart selection.
class ArtsyVariantThumbnails extends HTMLElement {
  connectedCallback() {
    // Quick Add clones product markup into a dialog with a noninteractive gallery.
    // Stay hidden there, including when its page fragment scripts do not execute.
    this.hidden = true;
    if (this.closest('dialog, quick-add-dialog') || !this.closest('.shopify-section')) return;
    this.hidden = false;
    this.addEventListener('click', this.selectColor);
  }
  disconnectedCallback() { this.removeEventListener('click', this.selectColor); }

  selectColor = (event) => {
    const button = event.target.closest?.('button[data-artsy-option-value-id]');
    if (!button || !this.contains(button)) return;
    const section = this.closest('.shopify-section');
    const picker = section?.querySelector('variant-picker[data-artsy-valid-options]');
    if (!picker || picker.dataset.productId !== this.dataset.productId) return;
    const selected = [...picker.querySelectorAll('input[type="radio"]:checked, select option:checked')]
      .map(input => input.dataset.optionValueId);
    const context = button.dataset.artsyPreviewContext?.split(',').filter(Boolean);
    // Old thumbnails cannot change a newly selected Style or Size while it loads.
    if (!context?.length || !context.every(id => selected.includes(id))) return;
    const id = button.dataset.artsyOptionValueId;
    const option = [...picker.querySelectorAll('[data-option-value-id]')]
      .find(input => input.dataset.optionValueId === id);
    if (!option || option.disabled || option.dataset.optionAvailable !== 'true') return;
    if (selected.includes(id)) return;
    const scrollLeft = this.scrollLeft;
    const focused = document.activeElement === button;
    const productId = this.dataset.productId;
    const onSelect = (selection) => {
      selection.promise?.then(() => requestAnimationFrame(() => {
        const rail = section.querySelector('artsy-variant-thumbnails');
        if (!rail || rail.dataset.productId !== productId) return;
        rail.scrollLeft = scrollLeft;
        const next = [...rail.querySelectorAll('button')].find(item => item.dataset.artsyOptionValueId === id);
        if (focused && document.activeElement === document.body) next?.focus({ preventScroll: true });
      })).catch(() => {}); // Native failure handling keeps the prior gallery.
    };
    picker.addEventListener(StandardEvents.productSelect, onSelect, { once: true });
    if (option instanceof HTMLOptionElement) {
      const select = option.closest('select');
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      option.checked = true;
      option.dispatchEvent(new Event('change', { bubbles: true }));
    }
    picker.removeEventListener(StandardEvents.productSelect, onSelect);
  };
}

if (!customElements.get('artsy-variant-thumbnails')) {
  customElements.define('artsy-variant-thumbnails', ArtsyVariantThumbnails);
}
